import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';

interface DateSeparatorProps {
    date: Date;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
    const formatDate = () => {
        if (isToday(date)) {
            return 'Today';
        } else if (isYesterday(date)) {
            return 'Yesterday';
        } else {
            return format(date, 'dd-MM-yyyy');
        }
    };

    return (
        <div className="w-full flex items-center justify-center my-4">
            <div className="bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full text-sm text-gray-500 dark:text-gray-400">
                {formatDate()}
            </div>
        </div>
    );
};

export default DateSeparator;